import { ProductDetails } from '@app/models/interfaces/product-details.interface';
import { ProductSubtypeEnum } from '@app/models/enums/product-subtype.enum';
import { ProductTypeEnum } from '@app/models/enums/product-type.enum';
import { UnifiedCardProductEnum } from '@app/products/unified-card/models/unified-card-product.enum';

const products: ProductDetails[] = [
    {
        modulePath: 'gene-expression/assay/query',
        name: 'Gene Expression',
        productType: ProductTypeEnum.ge,
        productSubType: ProductSubtypeEnum.ge,
        unifiedCardProductId: UnifiedCardProductEnum.TAQMAN_GE
    },
    {
        modulePath: 'gene-expression/array/query',
        name: 'Gene Expression',
        productType: ProductTypeEnum.gx,
        productSubType: ProductSubtypeEnum.gx,
        unifiedCardProductId: UnifiedCardProductEnum.ARRAY_GX
    },
    {
        modulePath: 'snp/assay/query',
        name: 'SNP Genotyping',
        productType: ProductTypeEnum.snp,
        productSubType: ProductSubtypeEnum.snp,
        unifiedCardProductId: UnifiedCardProductEnum.GT
    },
    {
        modulePath: 'cnv/assay/query',
        name: 'Copy Number',
        productType: ProductTypeEnum.cnv,
        productSubType: ProductSubtypeEnum.cnv,
        unifiedCardProductId: UnifiedCardProductEnum.CNV
    },
    {
        modulePath: 'microrna/assay/microrna-advanced',
        name: 'Advanced miRNA assays',
        productType: ProductTypeEnum.microrna,
        productSubType: ProductSubtypeEnum.microrna_advanced,
        unifiedCardProductId: UnifiedCardProductEnum.ADVANCED_MIRNA
    },
    {
        modulePath: 'microrna/assay/microrna-primary',
        name: 'Pri-miRNA assays',
        productType: ProductTypeEnum.microrna,
        productSubType: ProductSubtypeEnum.microrna_primary,
        unifiedCardProductId: UnifiedCardProductEnum.PRI_MIRNA
    },
    {
        modulePath: 'microrna/assay/microrna-classic',
        name: 'Classic miRNA assays',
        productType: ProductTypeEnum.microrna,
        productSubType: ProductSubtypeEnum.microrna_classic,
        unifiedCardProductId: UnifiedCardProductEnum.MIRNA_CONTROL_ASSAY
    },
    {
        modulePath: 'microrna/array',
        name: 'Advanced miRNA arrays',
        productType: ProductTypeEnum.microrna,
        productSubType: ProductSubtypeEnum.microrna_array,
        unifiedCardProductId: UnifiedCardProductEnum.ARRAY_MIRNA
    },
];

export { products };
